import axios from "axios";

import { IP } from "../utils/Host";


export function updateAddPrzerwaGant(global_id_grupa,czas,refreshGantAll,proces_nazwa_id) {

// id = procesor id



    if(proces_nazwa_id == 6 ){
 //oprawa
  axios.get(IP + "updateAddPrzerwaOprawa/"+global_id_grupa+"/"+czas)
    .then((res) => {
refreshGantAll()

    });

    }else{
      //pozostałe procesy
  axios.get(IP + "updateAddPrzerwa/"+global_id_grupa+"/"+czas)
    .then((res) => {
refreshGantAll()

    });

    }
}


